var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"easy-creative--integration"},[(_vm.isLoading)?_c('Loader',{attrs:{"text":_vm.$tCaption('Loading', '@actions') + '..',"fullscreen":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }